const config = {
  baseURL : 'http://localhost'
  // baseURL : 'https://rule.f1security.co.kr'
}

export default config;
